// OppSites Views/Review/ProductReview.cshtml の <style> をほぼそのまま移したもの。
// 見た目を変える意図が無い限り、クラス名・数値は原文のまま維持する。
// ただし本文列の幅だけは原文の 440px 固定をやめて flex で残り幅いっぱいにしてある
// （paper-straw の実ページで列が狭く見えた。A系統の旧ページは 80%、fukuro.in の
// 現行ページも display:flex + width:100% で、固定幅は他サイトにも合わない）。
// #review / #more_review だった id は、他ウィジェットと同じ作法で .wu-review 配下のクラスに変えてある。

export const css = `
.wu-review{ text-align:left; }
.wu-review .voice-box{
  display: flex;
  align-items: center;
  border-bottom-style: dashed;
  border-width: 1px;
  border-color: #181313;
  padding: 5px 0px 15px 10px;
  line-height: normal;
  font-size: 14px;
  margin: 10px 0px;
  position: relative;
}
.wu-review .voice-new{
  position: absolute;
  top: 10px;
  right: 10px;
}
.wu-review .face{
  margin-left: 10px;
  flex: none;
}
.wu-review .voice-content{
  margin-left: 30px;
  flex: 1 1 auto;
  min-width: 0;
}
.wu-review .voice{
  font-size: 15px;
}
.wu-review .products-label{
  color: red;
  font-weight: bold;
  float: left;
  font-size: 13px;
}
.wu-review .products{
  font-weight: bold;
  margin-left: 70px;
  font-size: 13px;
}
.wu-review .voice-box a{
  font-size: 14px;
  line-height: normal;
}
/* 「続きを読む」。旧 iframe（A系統）の画像ボタン（枠線つき・右寄せ）の見た目を CSS で作る（Issue #50）。
   画像は使わない（店ごとの画像 URL 管理を増やさない）。お客様の声ページと商品ページの両方に同じ見た目で効く。
   テーマの button タグセレクタに負けないよう、ここで見た目を全部指定する */
.wu-review .wu-more{
  margin-top: 30px;
  text-align: right;
}
.wu-review .wu-more button{
  display: inline-block;
  border: 1px solid #ccc;
  background: #f7f7f7;
  color: #333;
  padding: 6px 18px;
  font-size: 13px;
  font-family: inherit;
  line-height: 1.4;
  letter-spacing: .2em;
  border-radius: 2px;
  cursor: pointer;
  transition: background-color .15s, border-color .15s;
}
.wu-review .wu-more button:hover{
  background: #e8e8e8;
  border-color: #999;
}
.wu-review .wu-more button:focus-visible{
  outline: 2px solid #4a90e2;
  outline-offset: 2px;
}
.wu-review .wu-more button:disabled{
  opacity: .6;
  cursor: default;
}
.wu-review .date{
  font-size: 12px;
}
.wu-review .item{
  padding-bottom: 5px;
}
@media screen and (max-width: 480px){
  .wu-review .face{ margin-left: 0px; }
  .wu-review .voice-content{ margin-left: 10px; }
}
`
